import { GridItemsHeight } from "@multiweb/reactComponents";
import { OWDataType } from "@multiweb/types/contracts";

/** Výčtový typ sloužící k výběru typů atributů pro stories. */
export enum StoryAttributeTypes {
    date = OWDataType.date,
    time = OWDataType.time,
    dateTime = OWDataType.dateTime,
    string = OWDataType.string,
    boolean = OWDataType.boolean,
    icon = OWDataType.icon,
    document = OWDataType.document,
}

export const dateTypes = new Set<OWDataType>([
    OWDataType.date,
    OWDataType.time,
    OWDataType.dateTime,
]);

export const moneyNumberTypes = new Set<OWDataType>([
    OWDataType.decimal,
    OWDataType.money,
]);

export const realNumberTypes = new Set<OWDataType>([
    OWDataType.bcd,
    OWDataType.double,
    OWDataType.single,
]);

export const wholeNumberTypes = new Set<OWDataType>([
    OWDataType.byte,
    OWDataType.short,
    OWDataType.integer,
    OWDataType.int64,
]);

export const numberTypes = new Set<OWDataType>([
    ...moneyNumberTypes,
    ...realNumberTypes,
    ...wholeNumberTypes,
]);

/** Výčtový typ sloužící k výběru typu seznamu. */
export enum CommonListsTypes {
    infiniteVirtualizedList,
    responsiveList,
}

/**
 * Nastavení položky (MockGridLayoutItem) pro vygenerování pomocí funkce *generateGridItemsFromDivClassNames*.
 * @param divClassNames Pole CSS tříd pro položku.
 * @param height Výška generované položky.
 * @param gridItemsHeight Určuje, zdali si položky GridLayoutu zachovají výšku z definice (keepHeight), nebo se roztáhnou na výšku řádku.
 * @param order Určuje pozici položky v gridu
 */
export type GridItemOptions = {
    readonly divClassNames?: string[];
    readonly height?: number | string;
    readonly gridItemsHeight?: GridItemsHeight;
    readonly order?: number;
};
